import { Box, Divider, styled } from '@mui/material';

const Toolbox = ({
  children,
  underline,
  upperDivider = true,
  alignCenter = false,
}: React.PropsWithChildren<{
  underline?: boolean;
  upperDivider?: boolean;
  alignCenter?: boolean;
}>) => {
  return (
    <Box marginBottom={4}>
      {upperDivider ? <StyledDivider /> : null}
      <StyledToolBox alignCenter={alignCenter}>{children}</StyledToolBox>
      {underline ? <StyledDivider /> : null}
    </Box>
  );
};

const PushRight = ({ children }: React.PropsWithChildren<unknown>) => (
  <Box ml="auto" display="flex" flexWrap="wrap" gap={8} position="relative">
    {children}
  </Box>
);

const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.lwSecondary[20],
}));

const StyledToolBox = styled(Box, { shouldForwardProp: (prop) => prop !== 'alignCenter' })<{
  alignCenter: boolean;
}>(({ theme, alignCenter }) => ({
  gap: theme.spacing(8),
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(4),
  display: 'flex',
  justifyContent: alignCenter ? 'center' : 'flex-start',
  alignItems: alignCenter ? 'center' : 'flex-start',
}));

Toolbox.PushRight = PushRight;

export { Toolbox };
